import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useStyles } from './styles';

const Props = {
  size: PropTypes.oneOf(['small', 'medium', 'big']),
  value: PropTypes.oneOf([0, 1, 2, 3, 4, 5]).isRequired,
  onChange: PropTypes.func,
};

const DefaultProps = {
  size: 'small',
};

export default function RatingStars({ size, value: currentValue, onChange }) {
  const classes = useStyles({ size, interactive: !!onChange });

  function getImageSrc(value) {
    if (currentValue === 0 || value > currentValue) {
      return '/images/outlined-star-icon.svg';
    }

    return '/images/star-icon.svg';
  }

  function handleChange(value) {
    if (onChange) {
      onChange(value === currentValue ? 0 : value);
    }
  }

  return (
    <Box display="inline-flex" alignItems="center">
      {[1, 2, 3, 4, 5].map((value, index) => (
        <img
          key={index}
          className={classes.image}
          src={getImageSrc(value)}
          alt="Star icon"
          onClick={() => handleChange(value)}
        />
      ))}
    </Box>
  );
}

RatingStars.propTypes = Props;
RatingStars.defaultProps = DefaultProps;
